import { fakePortalConfig } from "./const"

const CHECK_MOCKUP = process.env.REACT_APP_IS_MOCKUP;

// API/system => /system/portalConfig
export const createSystemPortalConfigSlice = (set) => ({
  loading: false,
  portalConfig: {},
  isNavDisabled: false,

  setIsNavDisabled: (isDisabled) => set({ isNavDisabled: isDisabled }),

  fetchSystemPortalConfig: CHECK_MOCKUP === "true"
    ? () => {
      set({ portalConfig: fakePortalConfig.data })
    } : (ws, systemPortalConfigUuid, token) => {
      const request = {
        jsonrpc: "2.0",
        id: systemPortalConfigUuid,
        method: "read",
        params: {
          resource: "/system/portalConfig",
          accessToken: token,
        },
      };
      ws.send(JSON.stringify(request));
    },

  setPortalConfigLoading: (loadingState) => set({ loading: loadingState }),
  setPortalConfig: (data) => set({ portalConfig: data }),
});
